import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import InteractiveMap from './InteractiveMap';
import HallModal from './HallModal';
import { hallsData } from '../data/halls';
import SafeIcon from '../common/SafeIcon';
import { FiMaximize, FiX } from 'react-icons/fi';

export default function PlanSection() {
  const [selectedHallId, setSelectedHallId] = useState(null);
  const [isLageplanOpen, setIsLageplanOpen] = useState(false);
  
  const lageplanUrl = "https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/87a53ab5a34bd94e31b592a3ce4d37a9.png";

  return (
    <section id="hallenplan" className="py-24 bg-gray-50">
      <div className="container px-4 mx-auto md:px-8">
        <div className="flex flex-col items-center mb-16 text-center">
          <h2 className="section-title">Interaktiver Hallenplan</h2>
          <p className="section-subtitle">
            Klicken Sie auf die markierten Bereiche A–G, um detaillierte Informationen, 
            Grundrisse und Ausstattungsmerkmale der jeweiligen Halle zu erhalten.
          </p>
        </div>

        <div className="flex flex-col gap-12 lg:flex-row lg:items-start">
          {/* Map Area */}
          <div className="w-full lg:w-2/3">
            <InteractiveMap onSelectHall={setSelectedHallId} />
            
            <div className="flex justify-center mt-8">
              <button 
                onClick={() => setIsLageplanOpen(true)}
                className="btn-outline gap-2 cursor-pointer"
              >
                <SafeIcon icon={FiMaximize} />
                Lageplan öffnen
              </button>
            </div>
          </div>

          {/* Info Sidebar */}
          <div className="w-full p-8 bg-white border border-gray-200 rounded-sm shadow-sm lg:w-1/3">
            <h3 className="mb-4 text-2xl font-bold text-emerald-950">Schnellübersicht</h3>
            <ul className="space-y-4">
              {Object.values(hallsData).map((hall) => (
                <li 
                  key={hall.id}
                  className="flex items-center justify-between p-3 transition-colors rounded-sm cursor-pointer hover:bg-gray-50"
                  onClick={() => setSelectedHallId(hall.id)}
                >
                  <div className="flex items-center gap-3">
                    <span className={`flex items-center justify-center w-8 h-8 font-bold text-white rounded-sm ${hall.status === 'available' ? 'bg-emerald-800' : 'bg-gray-400'}`}>
                      {hall.id}
                    </span>
                    <span className={`font-medium ${hall.status === 'available' ? 'text-gray-800' : 'text-gray-400 line-through'}`}>
                      {hall.title}
                    </span>
                  </div>
                  <span className="text-xs font-semibold text-emerald-600">Details</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Hall Info Modal */}
      <HallModal 
        hall={selectedHallId ? hallsData[selectedHallId] : null} 
        isOpen={!!selectedHallId} 
        onClose={() => setSelectedHallId(null)}
        onNavigate={setSelectedHallId}
      />

      {/* Fullscreen Lageplan Lightbox */}
      <AnimatePresence>
        {isLageplanOpen && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-emerald-950/90 p-4 md:p-10 backdrop-blur-md"
            onClick={() => setIsLageplanOpen(false)}
          >
            <motion.button 
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="absolute top-6 right-6 z-[110] flex items-center justify-center w-12 h-12 bg-white text-emerald-950 rounded-full shadow-2xl hover:bg-gray-100 transition-colors"
            >
              <SafeIcon icon={FiX} className="text-2xl" />
            </motion.button>

            <motion.div 
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="relative max-w-full max-h-full p-4 md:p-8 bg-white rounded-sm shadow-[0_20px_50px_rgba(0,0,0,0.3)] overflow-hidden flex items-center justify-center"
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={lageplanUrl} 
                alt="Lageplan Industriegelände Heinsberg" 
                className="max-w-full max-h-[85vh] object-contain"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}